import React, { useState } from 'react';
import { X } from 'lucide-react';
import './CreateTicketModal.css';

function CreateTicketModal({ onClose, onSubmit }) {
  const [formData, setFormData] = useState({
    title: '',
    category: 'Genel',
    phone: '',
    sms_requested: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Yeni Talep Oluştur</h2>
          <button className="close-btn" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="ticket-form">
          <div className="form-group">
            <label htmlFor="title">Başlık *</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Sorununuzun kısa açıklaması"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="category">Kategori *</label>
            <select
              id="category"
              name="category"
              value={formData.category}
              onChange={handleChange}
              required
            >
              <option value="Genel">Genel</option>
              <option value="Küfür / Hakaret">Küfür / Hakaret</option>
              <option value="Hile / Bug">Hile / Bug</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="phone">Telefon Numarası (İsteğe Bağlı)</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="+905xxxxxxxxx"
            />
          </div>

          <div className="form-group checkbox-group">
            <label>
              <input
                type="checkbox"
                name="sms_requested"
                checked={formData.sms_requested}
                onChange={handleChange}
              />
              <span>SMS bildirimleri almak istiyor musunuz?</span>
              <small style={{display: 'block', marginTop: '5px', color: '#666', fontSize: '12px'}}>
                (SMS sadece yönetici tarafından manuel olarak gönderilecektir)
              </small>
            </label>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose}>
              İptal
            </button>
            <button type="submit" className="btn-primary">
              Talep Oluştur
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateTicketModal;
